import React, { useState } from 'react';
import { TextField, IconButton, Popover, Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock';
import dayjs from 'dayjs';

export default function CustomTimePicker({
  value,
  onChange,
  disabled,
  error,
  helperText,
  label,
  name
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (newValue) => {
    onChange(newValue);
    handleClose(); // close list after selection
  };

  const open = Boolean(anchorEl);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <TextField
          disabled={disabled}
          fullWidth
          name={name}
          label={label}
          value={value ? dayjs(value).format('HH:mm') : ''}
          error={error}
          helperText={helperText}
          InputProps={{
            endAdornment: (
              <IconButton onClick={handleOpen}>
                <AccessTimeIcon />
              </IconButton>
            )
          }}
          className="custom-textfield"
        />
      </Box>

      {/* Popover with DigitalClock */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <DigitalClock
          value={value}
          onChange={handleSelect}
          timeStep={15} // ✅ sirf 00, 15, 30, 45
          ampm={false}
        />
      </Popover>
    </LocalizationProvider>
  );
}
